module.exports = __webpack_public_path__ + "media/images/logo/logo_dokanto-a23226f3a0cb475b781d70f9de15b832.svg";